import React from 'react';

import PropTypes from 'prop-types';

function PaginationIndicator({ count, activeIndex }: any) {
    return (
        <div className='flex justify-center gap-2'>
            {Array.from({ length: count }).map((_: any, index: any) => {
                const isActive = index === activeIndex;
                const baseClass = 'rounded-full transition-all duration-200';
                const sizeAndColor = isActive ? 'h-2 w-2 bg-blue-500' : 'h-2 w-2 bg-slate-300';

                return (
                    <span
                        key={`pagination-dot-${index}`}
                        className={`${baseClass} ${sizeAndColor}`}
                        aria-hidden='true'
                    />
                );
            })}
        </div>
    );
}

PaginationIndicator.propTypes = {
    count: PropTypes.number.isRequired,
    activeIndex: PropTypes.number.isRequired,
};

export default PaginationIndicator;
